import { defaulted, string, trimmed } from 'superstruct';

/**
 * For validating search strings. Trims ends defaults to empty string.
 */
export const searchString = () => defaulted(trimmed(string()), '');